<template>
    <div class="quantity-input">
        <button
            type="button"
            class="quantity-input__btn quantity-input__btn--minus"
            @click="changeQuantity(-1)"
        >-</button>
        <button
            type="button"
            class="quantity-input__btn quantity-input__btn--plus"
            @click="changeQuantity(1)"
        >+</button>

        <input
            type="text"
            data-mask="product_quantity"
            v-model.number="localValue"
            inputmode="numeric"
            v-on="inputListeners"
            class="quantity-input__input"
            @keyup.down.up.prevent="keyupHandler"
            v-select-focus
        >
    </div>
</template>

<script>
export default {
    name: 'quantity-input',

    inheritAttrs: false,

    data() {
        return {
            localValue: this.value,
            minValue: 1,
        };
    },

    props: {
        inCart: {
            type: Boolean,
            // required: true,
        },

        value: {
            required: true,
        },
    },

    methods: {
        changeQuantity(value) {
            const newValue = +this.localValue + value;

            if (!newValue || newValue < this.minValue) {
                this.$emit('input', this.minValue);
                return;
            }

            this.$emit('input', newValue);
        },

        keyupHandler({ keyCode }) {
            if (keyCode === 40) {
                this.changeQuantity(-1);
                return;
            }

            this.changeQuantity(1);
        },
    },

    computed: {
        inputListeners() {
            return {
                ...this.$listeners,
                input: (event) => {
                    this.localValue = event.target.value || this.minValue;
                },
            };
        },
    },

    watch: {
        value(newValue) {
            if (newValue === this.localValue) return;

            this.localValue = newValue;
        },

        localValue(newLocalValue) {
            if (newLocalValue === this.value) return;

            if (newLocalValue === '') {
                this.$emit('input', '');
                return;
            }

            if (!newLocalValue || newLocalValue < this.minValue) {
                this.$emit('input', this.minValue);
                this.localValue = this.minValue;
                return;
            }

            this.$emit('input', newLocalValue);
        },
    },
};
</script>
